export default __webpack_public_path__ + "static/media/highlight-image-tooltip@2x.588401c9.png";